const SemVer = require('../classes/semver');
const parse = function (version, options) {
  let throwErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (version instanceof SemVer) {
    return version;
  }
  try {
    return new SemVer(version, options);
  } catch (er) {
    if (!throwErrors) {
      return null;
    }
    throw er;
  }
};
module.exports = parse;